
export const homeData = [
  {
    label: '日期',
    sortable: true,
    value: '1,statDate'
  },
//   {
//     label: '优化师ID',
//     width:120,
//     value: '2,personId'
//   },
  {
    label: '优化师名称',
    sortable: true,
    width: 140,
    value: '3,person'
  },
  {
    label: '渠道',
    sortable: true,
    width: 140,
    value: '38,channelName',
  },
  {
    label: '语言',
    width: 140,
    sortable: false,
    value: '1102,langName'
  },
  {
    label: '广告系列ID',
    sortable: true,
    width: 200,
    value: '43,campaignId'
  },
  {
    label: '广告系列名称',
    width:500,
    sortable: true,
    tooltip: true,
    resizable: true,
    tooltipMaxWidth: 300,
    value: '4,advertiseSeries'
  },
  {
    label: '广告组ID',
    sortable: true,
    width: 200,
    value: '41,adSetId'
  },
  {
    label: '广告组名称',
    sortable: true,
    width: 200,
    value: '42,adSetName'
  },
  {
    label: '广告名称',
    sortable: true,
    width: 200,
    value: '40,adName'
  },
  {
    label: '广告ID',
    sortable: true,
    width: 200,
    value: '39,adId'
  },

  {
    label: '投放金额',
    sortable: true,
    width: 120,
    value: '5,cost'
  },
  {
    label: '广告付费率 (纯新)',
    value: '59,payPercentNew',
    sortable: true,
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.payPercentNew
            ? (Number(params.row.payPercentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '广告付费率 (包含重归因)',
    value: '60,payPercentAll',
    sortable: true,
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.payPercentAll
            ? (Number(params.row.payPercentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '激活',
    sortable: true,
    value: '6,activation'
  },
  {
    label: '激活成本',
    sortable: true,
    width:120,
    value: '7,activationCost'
  },
  { label: '下单次数 (纯新)', value: '47,orderCountNew',sortable: true, },
  { label: '下单次数 (包含重归因)', value: '48,orderCountAll',sortable: true, },
  { label: '付费次数 (纯新)', value: '49,payCountNew',sortable: true, },
  { label: '付费次数 (包含重归因)', value: '50,payCountAll',sortable: true, },
  { label: '充值次数付费成本 (纯新)', value: '61,payCountCostNew',sortable: true, },
  { label: '充值次数付费成本 (包含重归因)', value: '62,payCountCostAll',sortable: true, },
  { label: '订阅人数 (纯新)', value: '51,subscribeUserCountNew',sortable: true, },
  { label: '订阅人数 (包含重归因)', value: '52,subscribeUserCountAll',sortable: true, },
  { label: '订阅率 (纯新)', value: '63,subscribePercentNew',sortable: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.subscribePercentNew
            ? (Number(params.row.subscribePercentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    } },
  { label: '订阅率 (包含重归因)', value: '64,subscribePercentAll',sortable: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.subscribePercentAll
            ? (Number(params.row.subscribePercentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    } },
  { label: '首日订阅金额 (纯新)', value: '53,firstDaySubscribeAmountNew',sortable: true, },
  {
    label: '首日订阅金额 (包含重归因)',
    value: '54,firstDaySubscribeAmountAll',sortable: true,
  },
  {
    label: '首日回本率',
    needCalc: true,
    width:120,
    sortable: true,
    value: '8,firstROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.firstROI
            ? (Number(params.row.firstROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '3日回本率',
    needCalc: true,
    sortable: true,
    width:120,
    value: '9,thirdROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.thirdROI
            ? (Number(params.row.thirdROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '8日回本率',
    needCalc: true,
    sortable: true,
    width:120,
    value: '10,eighthROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.eighthROI
            ? (Number(params.row.eighthROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '15日回本率',
    needCalc: true,
    sortable: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['fifthRecharge', 'cost']
    },
    value: '11,fifthROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.fifthROI
            ? (Number(params.row.fifthROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '30日回本率',
    needCalc: true,
    sortable: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['fifthRecharge', 'cost']
    },
    value: '12,thirtyROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.thirtyROI
            ? (Number(params.row.thirtyROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '60日回本率',
    sortable: true,
    needCalc: true,
    value: '13,sixtyROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.sixtyROI
            ? (Number(params.row.sixtyROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  { label: '广告投放类型', value: '44,advertiseTypeName',sortable: true, },
  { label: '独立付费用户数 (纯新)', value: '45,payUserCountNew',sortable: true, },
  { label: '独立付费用户数 (包含重归因)', value: '46,payUserCountAll',sortable: true, },
  
  {
    label: '支付成功率 (纯新)',
    value: '55,paySuccessPercentNew',
    sortable: true,
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.paySuccessPercentNew
            ? (Number(params.row.paySuccessPercentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '支付成功率 (包含重归因)',
    value: '56,paySuccessPercentAll',
    sortable: true,
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.paySuccessPercentAll
            ? (Number(params.row.paySuccessPercentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  { label: '独立用户付费成本 (纯新)', value: '57,payUserCostNew',sortable: true, },
  { label: '独立用户付费成本 (包含重归因)', value: '58,payUserCostAll',sortable: true, },
  
  
  {
    label: '首日充值金额',
    sortable: true,
    value: '15,firstRecharge'
  },
  {
    label: '累计3日充值金额',
    width:150,
    sortable: true,
    value: '16,thirdRecharge'
  },
  {
    label: '累计8日充值金额',
    width:150,
    sortable: true,
    value: '17,eighthRecharge'
  },
  {
    label: '累计15日充值金额',
    width:160,
    sortable: true,
    value: '18,fifthRecharge'
  },
  {
    label: '累计30日充值金额',
    width:160,
    sortable: true,
    value: '19,thirtyRecharge'
  },
  {
    label: '累计60日充值金额',
    width:160,
    sortable: true,
    value: '20,sixtyRecharge'
  },
  {
    label: '新增占比',
    value: '65,activationPercent',
    sortable: true,
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.activationPercent
            ? (Number(params.row.activationPercent) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '新增付费率',
    sortable: true,
    value: '66,activationPayPercent',
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.activationPayPercent
            ? (Number(params.row.activationPayPercent) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '3日增长倍数',
    sortable: true,
    value: '22,threeTimesGrowth'
  },
  {
    label: '8日增长倍数',
    sortable: true,
    value: '23,eightTimesGrowth'
  },
  {
    label: '15日增长倍数',
    sortable: true,
    value: '24,fifthTimesGrowth'
  },
  {
    label: '30日增长倍数',
    sortable: true,
    value: '25,thirtyTimesGrowth'
  },
  {
    label: '60日增长倍数',
    sortable: true,
    value: '26,sixtyTimesGrowth'
  },
  {
    label: '累计增长倍数',
    sortable: true,
    value: '27,allTimesGrowth'
  },
]

